import { setupSGWTConnect } from '@sgwt/connect-core';
import { getConfig } from './config';

export const sgwtConnect = setupSGWTConnect(getConfig().sgconnect);
